import axiosInstance from 'services/APIService';
import { PutAssetV2SetsAssetSetIdPostApiArg, PutAssetV2SetsAssetSetIdPostApiResponse } from 'store/api/apiGenerated';

const ENDPOINT_PATH = `/v1/sets/asset`;

/*
 * Gets an asset (image) from the backend
 */
export const get = async (filename: string): Promise<string> => {
  const response = await axiosInstance.get<string>(`${ENDPOINT_PATH}/${filename}`, { responseType: 'blob' });
  try {
    return URL.createObjectURL(new Blob([response.data]));
  } catch (e) {
    return response.data;
  }
};

/*
 * Uploads an asset (image) to the backend
 */
export const post = async (filename: string, image: File): Promise<void> => {
  const data = new FormData();
  data.append('image', image, image.name);
  await axiosInstance.post<string>(`${ENDPOINT_PATH}/${filename}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const putAssetV2SetsAssetSetIdPost = async (
  queryArg: PutAssetV2SetsAssetSetIdPostApiArg,
): Promise<PutAssetV2SetsAssetSetIdPostApiResponse> => {
  const data = new FormData();
  data.append('file', queryArg.bodyPutAssetV2SetsAssetSetIdPost.file);
  const response = await axiosInstance.post<PutAssetV2SetsAssetSetIdPostApiResponse>(
    `/v2/sets/asset/${queryArg.setId}/`,
    data,
    {
      params: { asset_type: queryArg.assetType, region: queryArg.region },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  );

  return response.data;
};
